<div class="wrapper-page">
  <app-my-content></app-my-content>
  <div class="wrapper-home-page">
    <tl-header></tl-header>
    <div class="home-page">
      <div class="wrapper-header-home-page">
        <div class="header-home-page">
          <div class="info-header">
            <span class="title">{{'NEW_TEXT.latest_posts' | translate}}</span>
            <span class="subtitle">{{'HOME.latest_posts_of_the_people_you_follow.' | translate}}</span>
          </div>
          <button [routerLink]="[PAGES_AND_PATHS.latestPost.pagePath]" type="submit"
            class="custom-btn custom-btn--gray">
            <span>{{'NEW_TEXT.view_all' | translate}}</span>
          </button>
        </div>
        <swiper-container class="mySwiper wrapper-latest-post" slides-per-view="1.5">
          <swiper-slide *ngFor="let post of homepageData?.followedUsersPosts">
            <app-latest-post [post]="post" [routerLink]="[PAGES_AND_PATHS.singlePost.pagePath, post.id]"
              (isSharePostModalOpen)="isSharePostModalOpen = $event" (isReportPostModalOpen)="openReport($event)"
              (selectedPost)="getSelectedPost($event)"></app-latest-post>
          </swiper-slide>
        </swiper-container>
        <div class="header-home-page">
          <div class="info-header">
            <span class="title">{{'NEAR_YOU_PAGE.listers' | translate}}</span>
            <span class="subtitle">
              {{'HOME.updated_hourly_most_popular_listers_ranking_in_the_region' | translate}}
            </span>
          </div>
          <!-- <button type="submit" class="custom-btn custom-btn--gray">
            <span>View all</span>
          </button> -->
        </div>
        <swiper-container class="mySwiper wrapper-listers-home-page" slides-per-view="5">
          <swiper-slide *ngFor="let lister of homepageData?.suggestedFriendsExperts.users">
            <app-lister [lister]="lister" [routerLink]="[PAGES_AND_PATHS.profile.pagePath, lister?.username]"></app-lister>
          </swiper-slide>
        </swiper-container>
        <div class="header-home-page" *ngIf="homepageData?.recommendedSubcategories">
          <div class="info-header">
            <span class="title">{{'HOME.continue_browsing' | translate}}</span>
          </div>
        </div>
        <swiper-container class="mySwiper wrapper-themes-home" slides-per-view="3.3">
          <swiper-slide *ngFor="let theme of homepageData?.recommendedSubcategories">
            <app-theme [routerLink]="[PAGES_AND_PATHS.singleTheme.pagePath, theme.id]" [theme]="theme"
              [style.background-color]="theme?.color" class="wrapper-card-theme"></app-theme>
          </swiper-slide>
        </swiper-container>
        <div class="header-home-page">
          <div class="info-header">
            <span class="title">
              {{'HOME.recommended_lists' | translate}}
            </span>
          </div>
          <button [routerLink]="PAGES_AND_PATHS.recommendedLists.pagePath" type="submit"
            class="custom-btn custom-btn--gray">
            <span>{{'NEW_TEXT.view_all' | translate}}</span>
          </button>
        </div>
        <div class="grid">
          <app-list class="grid__s-4" *ngFor="let list of homepageData?.recommendedLysts"
            [list]="list"></app-list>
        </div>
      </div>
    </div>
  </div>
</div>
<app-report-modal *ngIf="isReportPostModalOpen" [entityId]="selectedPost?.id" [entityType]="'post'"
  (closeModal)="isReportPostModalOpen = false" (reportSent)="isReportPostModalOpen = false">
</app-report-modal>

<tl-sharing-options-modal *ngIf="isSharePostModalOpen" [entityType]="ShareEntitiesEnums.post"
  [entityId]="selectedPost?.id" [urlForShare]="postUrl"
  (closeModal)="isSharePostModalOpen = false"></tl-sharing-options-modal>
